module.exports = __webpack_public_path__ + "static/media/preferred_lang.9834c9b3.mp3";